import React from 'react';
import { StyleSheet, View } from 'react-native';

import { ContentfulImage, type ContentfulImageTransformOptions, Icon, theme } from '@sg/garnish';

import { IdMeVerifiedBadge } from '../IdMeVerifiedBadge';

// ─────────────────────────────────────────────────────────────────────────────

export const IdMeLogoLockup = (props: Props) => {
  const { withVerifiedBadge, partnerLogo } = props;

  return (
    <View style={styles.container}>
      {withVerifiedBadge ? <IdMeVerifiedBadge /> : <Icon name="IconIdMe" width={85} height={43} />}

      {partnerLogo ? <View style={styles.divider} /> : null}

      {partnerLogo ? (
        <ContentfulImage
          baseUrl={partnerLogo.url}
          alt={partnerLogo.alt}
          options={PARTNER_LOGO_OPTIONS}
          contentFit="contain"
          style={styles.partnerLogo}
        />
      ) : null}
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const PARTNER_LOGO_OPTIONS: Partial<ContentfulImageTransformOptions> = { fm: 'webp', h: 96 };

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['3'],
    height: 60,
  },
  divider: {
    width: 1,
    height: 40,
    backgroundColor: theme.colors.CHARCOAL,
  },
  partnerLogo: {
    width: 92,
    height: 32,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  withVerifiedBadge?: boolean;
  partnerLogo?: {
    url: string;
    alt: string;
  };
};
